import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-handle",
  "use": "icon-handle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-handle\">\n<path d=\"M7 2H9.15647V4.15647H7V2ZM7 7.03177H9.15647V9.18824H7V7.03177ZM7 12.0635H9.15647V14.22H7V12.0635Z\" fill=\"#444444\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol